//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import seguroEmpateMixin from '~/mixins/seguro-empate'

export default {
  name: 'ElementsSeguroEmpateToggle',
  mixins: [seguroEmpateMixin],
  props: {
    selection: {
      default: null
    },
    freebet: {
      default: null
    }
  },
  data() {
    return {
      showDetails: false
    }
  },
  computed: {
    /**
     * Covered by the promotion - scope and market. Independent of bet type and of
     * the conditions that can change while the selection sits in the betslip, so a
     * switch to combi is not mistaken for going out of scope.
     */
    selectionInScope() {
      return this.seguroEmpateSelectionInScope(this.selection)
    },
    eligible() {
      if (this.betType !== 'single') return false
      return this.selectionInScope
    },
    betType() {
      return this.$store.state.betslip.betType
    },
    /**
     * The stored opt-in. Kept even while the bet does not qualify, so the choice
     * comes back if the customer removes the freebet or the odds recover.
     */
    insuredStored() {
      return this.seguroEmpateInsured(this.selection)
    },
    /**
     * Active insurance - shared with the shield and chip on the line so the three
     * markers cannot disagree. Never true while disabled, since showing the switch
     * ON would promise a freebet this bet would not receive.
     */
    insured() {
      return this.seguroEmpateActive(this.selection, this.freebet)
    },
    stake() {
      return this.seguroEmpateSelectionStake(this.selection)
    },
    eventAlreadyInsured() {
      return this.seguroEmpateEventAlreadyInsured(this.selection)
    },
    /**
     * The campaign covering this selection's event - resolved once and reused
     * below instead of re-scanning campaigns per field.
     */
    campaign() {
      return this.seguroEmpateCampaignFor(_.get(this.selection, 'event'))
    },
    minOdds() {
      return this.seguroEmpateMinOddsFor(_.get(this.selection, 'event'))
    },
    minStake() {
      return this.seguroEmpateMinStakeFor(_.get(this.selection, 'event'))
    },
    validDays() {
      return parseInt(_.get(this.campaign, 'prizes[0].freebet_valid_days', 0)) || null
    },
    conditionSegments() {
      return this.seguroEmpateConditionSegmentsFor(_.get(this.selection, 'event'))
    },
    freebetAmount() {
      return this.seguroEmpateFreebetAmount(this.selection, this.stake)
    },
    freebetLabel() {
      if (this.freebetAmount === null) return null
      // format_money() works in cents.
      return `${this.$t('DRAW_INSURANCE_FREEBET_IF_DRAW')}: ${this.format_money(this.freebetAmount * 100)}`
    },
    disabledReason() {
      if (this.seguroEmpateIsDrawOutcome(this.selection)) {
        return this.$t('DRAW_INSURANCE_AVAILABLE_ON_HOME_OR_AWAY')
      }
      if (this.eventAlreadyInsured) return this.$t('DRAW_INSURANCE_ONE_PER_MATCH')
      if (this.freebet) return this.$t('DRAW_INSURANCE_NOT_AVAILABLE_WITH_FREEBET')
      if (this.seguroEmpateOddsBelowMinimum(this.selection)) {
        return `${this.$t('DRAW_INSURANCE_AVAILABLE_FROM_ODDS')} ${this.minOdds.toFixed(2)}`
      }
      if (this.minStake && this.stake && this.stake < this.minStake) {
        return `${this.$t('DRAW_INSURANCE_MINIMUM_BET_AMOUNT')}: ${this.format_money(this.minStake * 100)}`
      }
      return null
    },
    disabled() {
      return !!this.disabledReason
    },
    /**
     * Conditions the design keeps out of the main sentence - shown under the (i)
     * rather than crowding every line in the betslip.
     */
    requirements() {
      const list = [
        this.$t('DRAW_INSURANCE_SINGLE_BETS_MATCH_RESULT_ONLY'),
        this.$t('DRAW_INSURANCE_PRE_MATCH_BETS_ONLY')
      ]
      if (this.minOdds) {
        list.push(`${this.$t('DRAW_INSURANCE_MINIMUM_ODDS')}: ${this.minOdds.toFixed(2)}`)
      }
      if (this.validDays) {
        const key = this.validDays === 1
            ? 'DRAW_INSURANCE_CONDITIONS_EXPIRY_ONE_DAY'
            : 'DRAW_INSURANCE_CONDITIONS_EXPIRY'
        list.push(this.$t(key).replace('{days}', this.validDays))
      }
      return list
    }
  },
  watch: {
    /**
     * Drop the opt-in only when the selection leaves the promotion's scope for
     * good - the market changed, the match went live.
     *
     * Deliberately not watching `eligible` or `disabled`: a combi switch, an
     * applied freebet and a dipped price are all reversible, and clearing on
     * those would lose a choice the customer made. Those states disable the
     * switch and render it OFF instead, and placement re-checks eligibility
     * before the opt-in is sent.
     */
    selectionInScope(value) {
      if (!value && this.insuredStored) this.seguroEmpateSetInsured(this.selection, false)
    }
  },
  methods: {
    toggle() {
      if (this.disabled) return
      this.seguroEmpateSetInsured(this.selection, !this.insuredStored)
    }
  }
}
